import { createRouter, createWebHashHistory } from "vue-router";

import DashboardLayout from "@/layout/DashboardLayout";
import AuthLayout from "@/layout/AuthLayout";

import Dashboard from "../views/Dashboard.vue";
import Users from "../views/Users.vue";
import Devices from "../views/Devices.vue";
import Groups from "../views/Groups.vue";
import Solvents from "../views/Solvents.vue";
import Experiences from "../views/Experiences.vue";

import UserProfile from "../views/UserProfile.vue";

import Login from "../views/Login.vue";
import Register from "../views/Register.vue";
import Forgot from "../views/Forgot.vue";

import store from "../store";

const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
      next();
      return;
    }
    next("/");
};
  
const ifAuthenticated = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next();
        return;
    }
    next("/login");
};

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
    component: DashboardLayout,
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        beforeEnter: ifAuthenticated,
        components: { default: Dashboard },
      },
      {
        path: "/users",
        name: "users",
        beforeEnter: ifAuthenticated,
        components: { default: Users },
      },
      {
        path: "/instruments",
        name: "instruments",
        beforeEnter: ifAuthenticated,
        components: { default: Devices },
      },
      {
        path: "/groups",
        name: "groups",
        beforeEnter: ifAuthenticated,
        components: { default: Groups },
      },
      {
        path: "/solvents",
        name: "solvents",
        beforeEnter: ifAuthenticated,
        components: { default: Solvents },
      },
      {
        path: "/experiences",
        name: "experiences",
        beforeEnter: ifAuthenticated,
        components: { default: Experiences },
      },
      {
        path: "/profile",
        name: "profile",
        beforeEnter: ifAuthenticated,
        components: { default: UserProfile },
      }
    ],
  },
  {
    path: "/",
    redirect: "login",
    component: AuthLayout,
    beforeEnter: ifNotAuthenticated,
    children: [
      {
        path: "/login",
        name: "login",
        components: { default: Login },
      },
      {
        path: "/register",
        name: "register",
        components: { default: Register },
      },
      {
        path: "/forgot",
        name: "forgot",
        components: { default: Forgot },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  linkActiveClass: "active",
  routes,
});

export default router;
